module.exports = __webpack_public_path__ + "img/img01.6cc9b811.png";